module.exports = __webpack_public_path__ + "static/media/nami-electrico.2abc589e.svg";